import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../ui/UIElements/Icon";
import CartRecoveryForm from "./CartRecoveryForm";

const CartRecoveryCreatePage = () => {
  const { t } = useTranslation("cartRecovery");
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/growth/cart-recovery");
  };

  const handleCreated = (created) => {
    const id = created?.id ?? created?.result?.id;
    if (id) {
      navigate(`/growth/cart-recovery/${id}`);
      return;
    }
    handleBack();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={handleBack}
          className="rounded-lg p-2 transition-colors hover:bg-gray-800"
          aria-label={t("create.back")}
        >
          <Icon name="ArrowLeft" className="h-5 w-5 text-gray-400" />
        </button>
        <div>
          <h1 className="text-xl font-bold text-white sm:text-2xl">
            {t("create.title")}
          </h1>
          <p className="mt-1 text-gray-400">{t("create.subtitle")}</p>
        </div>
      </div>

      <CartRecoveryForm
        mode="create"
        onCancel={handleBack}
        onSuccess={handleCreated}
      />
    </div>
  );
};

export default CartRecoveryCreatePage;
